import * as yup from 'yup';

export const CHAT_TYPE = {
    CHAT_TYPE_MATCHING_SELLER: 'matching_seller',
    CHAT_TYPE_MATCHING_BUYER: 'matching_buyer',
    CHAT_TYPE_SUPPORT: 'support',
};
export type ChatTypes = (typeof CHAT_TYPE)[keyof typeof CHAT_TYPE];

export const chatRoomSchema = yup.object({
    id: yup.number().required(),
    match: yup.object({
        id: yup.number().required(),
        from_agent_user: yup.object({
            id: yup.number().required(),
            last_name: yup.string().required(),
            first_name: yup.string().required(),
            job: yup.string().required(),
            department: yup.string().required(),
            icon_image: yup.string().required(),
        }),
        agent: yup.object({
            id: yup.number().required(),
            name: yup.string().required(),
            icon_image: yup.string().required(),
        }),
        company: yup.object({
            id: yup.number().required(),
            name: yup.string().required(),
            icon_image: yup.string().required(),
        }),
        buyer: yup.object({
            id: yup.number().required(),
            name: yup.string().required(),
            icon_image: yup.string().required(),
        }),
        date_matched: yup.string().required(),
        meeting_date: yup.string().nullable(),
        message_from_brokerage: yup.string().required(),
        premium_offer: yup.boolean().optional(),
        status: yup.string().required(),
        meeting_date_confirmation: yup
            .object({
                tentative_meeting_date: yup.string().required(),
                requesting_company_user: yup.object(),
                requesting_agent_user: yup.object(),
                requesting_buyer_user: yup.object(),
            })
            .nullable(),
        archived: yup.boolean().required(),
        archived_reason: yup.string().nullable(),
    }),
    chat_type: yup.string().oneOf(Object.values(CHAT_TYPE)).required(),
    last_message_text: yup.string().nullable(),
    last_message_sent_at: yup.string().nullable(),
    unread: yup.boolean().required(),
});

export type IChatRoom = yup.InferType<typeof chatRoomSchema>;
